export default __webpack_public_path__ + "static/media/334731_quora_icon.5f4465e0.png";